import React from "react";
import { Dialog, Modal, XIcon } from "staysure-component-library";

import { IconButtonWrapper } from "@/components/atoms/button-wrapper/button-wrapper";

type ModalWrapperType = {
  isOpen: boolean;
  setIsOpen: (e: boolean) => void;
  isShowIcon?: boolean;
  children?: React.ReactNode;
  isClosedByCtaOnly?: boolean;
};

export function ModalWrapper({
  isOpen,
  setIsOpen,
  isShowIcon = true,
  isClosedByCtaOnly = false,
  children,
}: Readonly<ModalWrapperType>) {
  return (
    <Modal
      onOpenChange={(e: boolean) => {
        if (!isClosedByCtaOnly) {
          setIsOpen(e);
        }
      }}
      isOpen={isOpen}
      isDismissable={!isClosedByCtaOnly}
      modalStyles={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
      className="bg-surface-neutral-option-1 md:w-[416px] sm:w-[327px] relative rounded-radius-lg  max-h-[100dvh] overflow-y-auto"
      uderlayClassName="z-[105] bg-interactive-overlay-default w-[100%] !fixed !top-0 !left-0 h-[100dvh]"
    >
      <Dialog
        className="relative "
        style={{ maxHeight: "calc(100dvh - 48px)" }}
      >
        <div className="md:p-spacing-xxxl p-spacing-l ">
          {isShowIcon && (
            <div className="md:w-spacing-xxxl md:h-spacing-xxxl w-spacing-xxl h-spacing-xxl m-spacing-xxs md:m-0  absolute right-0 top-0 flex items-center justify-center">
              <IconButtonWrapper
                data-testid="overlay-close-button-test-id"
                id="modal-close-button"
                hierarchy="tertiary"
                btnType="icon"
                icon={<XIcon stroke="#306582" />}
                className="w-[24px] h-[24px] text-[24px] text-text-on-primary "
                onClick={() => {
                  if (setIsOpen !== undefined) {
                    setIsOpen(false);
                  }
                }}
              />
            </div>
          )}
          {children}
        </div>
      </Dialog>
    </Modal>
  );
}
